"use client";

import TitleUI from "@/components/ui/title";
import { I18nText, useI18nText } from "@/hooks/useI18nText";

export default function Title(props: {
  data?: {
    title?: I18nText;
  };
}) {
  const { translation } = useI18nText();
  return (
    <div className="w-full text-center">
      {props.data?.title && (
        <TitleUI title={translation(props.data.title)} underline={false} />
      )}
    </div>
  )
}